import { PureComponent, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
export default class AutocompleteToggle extends PureComponent {
  static propTypes = {
    children: PropTypes.element,
    name: PropTypes.string,
    isAutocompleteAllowed: PropTypes.bool,
    getRef: PropTypes.func
  };
  static defaultProps = {
    isAutocompleteAllowed: false,
    name: '',
    children: /*#__PURE__*/React.createElement("input", null)
  };
  constructor(props) {
    super(props);
    this.cid = shortid.generate();
  }
  render() {
    const {
      getRef,
      children,
      name,
      isAutocompleteAllowed,
      ...props
    } = this.props;
    return /*#__PURE__*/cloneElement(Children.only(children), {
      ...props,
      ref: getRef,
      autoComplete: isAutocompleteAllowed ? 'on' : this.cid,
      name: isAutocompleteAllowed ? name : `${this.cid}_${name}`
    });
  }
}